import SplitHero from '@sections/SplitHero';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context';

const AboutFranchiseHero = ({ data, blockContext, localCtaData, handleChangeLocation }) => {
    const { franchise } = useMicrosite();

    const { flag } = useStaticQuery(graphql`
    query {
      flag: file(relativePath: { eq: "servproflag.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 600
            height: 700
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);

    const image = franchise?.aboutUs?.ownerPicture ? {
        filename: franchise?.aboutUs?.ownerPicture,
        title: franchise?.aboutUs?.ownerPicture,
        description: franchise?.aboutUs?.owners || `${franchise?.aboutUs?.multipleOwners ? 'Owners' : 'Owner'} of ${franchise?.name}`,
        caption1: franchise?.aboutUs?.displayOwners && franchise?.aboutUs?.owners,
        caption2: franchise?.aboutUs?.ownerPicture && `${franchise?.aboutUs?.multipleOwners ? 'Owners' : 'Owner'} of ${franchise?.name}`,
        url: franchise?.aboutUs?.ownerPicture,
        contentStackAsset: {
            childImageSharp: {
                height: 600,
                width: 700,
                backgroundColor: '#8b8b8a',
                images: {
                    fallback: {
                        src: franchise?.aboutUs?.ownerPicture,
                        srcSet: `${franchise?.aboutUs?.ownerPicture}?width=640 640w,\n${franchise?.aboutUs?.ownerPicture}?width=3840 3840w,\n${franchise?.aboutUs?.ownerPicture}?width=1920 1920w`,
                        sizes: '(min-width: 1920px) 1920px, 100vw',
                    },
                    sources: [
                        {
                            srcSet: `${franchise?.aboutUs?.ownerPicture}?width=640&auto=webp 640w,\n${franchise?.aboutUs?.ownerPicture}?width=3840&auto=webp 3840w,\n${franchise?.aboutUs?.ownerPicture}?width=1920&auto=webp 1920w`,
                            type: 'image/webp',
                            sizes: '(min-width: 1920px) 1920px, 100vw',
                        },
                    ],
                },
                layout: 'constrained',
            },
            publicURL: `${franchise?.aboutUs?.ownerPicture}`,
        },
    } : {
        filename: flag.childImageSharp.gatsbyImageData.images.fallback.src,
        title: 'SERVPRO Flag',
        description: 'SERVPRO Flag',
        caption1: franchise?.aboutUs?.displayOwners && franchise?.aboutUs?.owners,
        url: flag.childImageSharp.gatsbyImageData.images.fallback.src,
        ...flag,
    };

    return (
        <SplitHero
            data={{
                ...data,
                image,
                has_location_widget: true,
            }}
            localCtaData={blockContext?.localCtaData ? blockContext.localCtaData : localCtaData}
            handleChangeLocation={handleChangeLocation}
        />
    );
};
export const query = graphql`
  fragment AboutFranchiseHeroData on CmsPageBuilderBlocks {
    about_franchise_hero { 
      heading
      subheading
      copy
    }
  }
`;

export default AboutFranchiseHero;
